import { Pipe, PipeTransform } from "@angular/core";
import { getAdditionalBookings } from "../functions/booking-utils.functions";
import { NsEmpWebExpData } from "../models/emp-web-exp.model";

@Pipe({
  name: "additionalType"
})
export class AdditionalTypePipe implements PipeTransform {
  transform(value: NsEmpWebExpData.IBookingDetailDTOS, types: string[]): boolean {
    return !!getAdditionalBookings(value, types)?.length;
  }
}
